'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalEventBus = undefined;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The global event bus is a headless vue instance that is used simply to
 * allow components to talk with each other.
 *
 * This prevents the app from spamming events to the window element
 * and uses a more internal way of communication instead.
 *
 * It is advised to prefix fired events by the name of the component that
 * fired it to make debugging easier.
 *
 * Bad example:  globalEventBus.$emit('navigation')
 * Good example: globalEventBus.$emit('tabmenu.navigation')
 *
 * The events can be fired by using vues `$emit` and `$on` methods
 */
var globalEventBus = exports.globalEventBus = new _vue2.default();